export default {
  files: [],
  dialogState: false,
  directories: '',
  bucket: 'risc-clinic-atualizacoes',
}
